export const MCP_CONTRACT_CELL_WIDTH = {
    contract: 150,
    startDate: 120,
    endDate: 125,
    credits: 100,
    overages: 100,
    remainingCredits: 120,
    remainingOverages: 120,
};

export const MCP_TABS = {
    SETUP: {
        name: 'setup',
        caption: 'Setup',
    },
    PRICING: {
        name: 'pricing',
        caption: 'Pricing',
    },
    ALERTS: {
        name: 'alerts',
        caption: 'Alerts',
    },
};

export const MCP_CREDENTIAL_ERROR_MESSAGE =
    'Must not contain Cyrillic symbols';

const CYRILLIC_PATTERN = /[Ѐ-ӿ]/;
export const isValidMcpCredential = (value: string) =>
    !CYRILLIC_PATTERN.test(value);
